/* @flow */
import querystring from "querystring";
import { getSub0 } from "../Subzero";

function getOAuthSpec(network) {
  switch (network) {
    case "fb":
      return {
        dialog: "https://www.facebook.com/v2.10/dialog/oauth",
        client_id: window.FACEBOOK_CLIENT_ID,
        redirect_uri: window.FACEBOOK_REDIRECT_URI,
        scope: "email"
      };
    case "gp":
      return {
        dialog: "https://accounts.google.com/o/oauth2/v2/auth",
        client_id: window.GOOGLE_CLIENT_ID,
        redirect_uri: window.GOOGLE_REDIRECT_URI,
        scope:
          "https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile"
      };
    default:
      throw new TypeError("Unknown network type");
  }
}

function loginWith(network, props) {
  const { dialog, client_id, redirect_uri, scope } = getOAuthSpec(network);

  const { origin, pathname, search } = window.location;
  const parsedSearch = querystring.parse(search.slice(1)) || {};
  //сабы которые мы привыкли видеть в Сабзиро в этом урле спрятаны под такими именами
  const sub1 = parsedSearch.media_source;
  const sub2 = parsedSearch.campaign;
  const authSearchParams = {
    ...parsedSearch,
    sub0: getSub0(window.location, { isIOS: props.isIOS })
  };
  if(sub1 != null) {
    authSearchParams.sub1 = sub1;
  }
  if(sub2 != null) {
    authSearchParams.sub2 = sub2;
  }

  const query = {
    client_id,
    redirect_uri,
    scope,
    response_type: "code",
    state: JSON.stringify({
      redirect:
        origin + pathname + "?" + querystring.stringify(authSearchParams), // TODO: Сделать более предсказуемо
      ref_user: props.ref_user,
      locale: props.locale,
      currency:
        process.env.REACT_APP_DEPLOY_TARGET === "siamoption" ? "THB" : undefined
      // Страны может не быть только если это irontrade,
      // и пользователь её пока не выбрал. При этом соци-
      // альная регистрация доступна только для гео Вьет-
      // нама, поэтому VND это наш дефолт.
      /*currency: props.country != null
        ? props.country.currency
        : "VND"*/
    })
  };

  return dialog + "?" + querystring.stringify(query);
}

export default loginWith;



// WEBPACK FOOTER //
// ./src/components/Auth/loginWith.js